import React from "react";

function CustomChatMessage() {
  return (
      <div className="custom-chat-message-text"></div>
  );
}
export default CustomChatMessage;